'use client';

import { usePathname } from 'next/navigation';
import LandingLoading from './(landing)/loading';
import HomeLoading from './home/loading';
import ExploreLoading from './workspaces/loading';
import DetailsLoading from './workspaces/[country]/[city]/[workspace]/loading';
import SubscriptionsLoading from './memberships/loading';
import styles from './loading.module.scss';

// Default Suspense fallback. Routes a known pathname to its page-specific
// skeleton so we never flash a spinner when navigating to a page that has
// one. The skeleton modules are statically imported here so they live in
// the always-loaded layout chunk — that's what closes the first-navigation
// gap where the per-route loading.tsx wouldn't yet be downloaded.
//
// When you add a new page-level loading.tsx, add a branch here too.
export default function Loading() {
  const pathname = usePathname() || '';
  if (pathname === '/') return <LandingLoading />;
  if (pathname === '/home') return <HomeLoading />;
  if (/^\/workspaces\/[^/]+\/[^/]+\/[^/]+/.test(pathname)) return <DetailsLoading />;
  if (pathname.startsWith('/workspaces')) return <ExploreLoading />;
  if (pathname.startsWith('/memberships')) return <SubscriptionsLoading />;

  // Fallback for routes without a specific skeleton.
  return <div className={styles.overlay} role="status" aria-live="polite" aria-label="Loading" data-sentry-component="Loading" data-sentry-source-file="loading.tsx">
            <span className={styles.spinner} aria-hidden="true" />
        </div>;
}